<template>
  <div class="d-flex align-items-center h-100">
    <b-card class="mx-auto loginFormCard" header-tag="header">
      <h5 slot="header" class="mb-0" align="center">Восстановление пароля</h5>
      <b-form
        @submit.prevent="validate"
      >
        <b-form-group
          label="Почта"
          label-for="emailInput"
          description="Введите почту, с которой вы были зарегистрированы в данной системе."
        >
          <b-form-input
            id="emailInput"
            v-model="email"
            type="email"
            required
            placeholder="Введите почту"
          ></b-form-input>
        </b-form-group>
        <div class="form-group">
          <vue-recaptcha
            ref="recaptcha"
            size="invisible"
            @verify="onSubmit"
            @expired="onCaptchaExpired"
            :sitekey="recaptchaKey"
          />
        </div>
        <b-button
          block
          type="submit"
          variant="outline-primary"
        >
          <em class="fas fa-sign-in" aria-hidden="true"></em> Отправить ссылку на изменение пароля
        </b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import usersApi from '@/api/users'

export default {
  name: 'PasswordRecoverForm',
  components: {
    VueRecaptcha
  },
  data() {
    return {
      email: '',
      recaptchaKey: '6LdBkCwaAAAAAByMmZvtALn9ye1Qa1lZxFq9g98N'
    }
  },
  methods: {
    onSubmit(recaptchaToken) {
      usersApi.resetPassword({ email: this.email, captcha: recaptchaToken })
        .then(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: `На почту <strong>${this.email || ''}</strong> отправлено письмо с ссылкой для восстановления пароля.
                      Если письмо не пришло, попробуйте проверить спам или корректность написанного Вами адреса.`,
            time: 60
          })
        })
        .catch(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Повторить попытку сброса пароля можно через 5 минут',
            time: 3
          })
        })
      this.$refs.recaptcha.reset()
    },
    validate() {
      this.$refs.recaptcha.execute()
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  }
}
</script>

<style scoped>
  .card-header{
    background-color: #017ac3;
    color: white;
  }

  .card{
    width: 60vw;
    max-width: 900px;
  }

  @media only screen and (max-width: 768px) {
    .card{
      width: 90vw;
    }
  }

  @media only screen and (max-width: 480px) {
    .loginFormCard__loginButton {
      width: 100%;
      margin-top: 10px;
    }
  }
</style>
